export enum ChecklistAnalyticsActionTypes {
  ADD_SUBTASK_ANALYTICS = '[Analytics] [Checklist] Added subtask',
  ADD_TASK_ANALYTICS = '[Analytics] [Checklist] Added main task',
  CHANGED_MAIN_TASK_PERIOD_ANALYTICS = '[Analytics] [Checklist] Changed main task period',
  CHECKLIST_INITIAL_IDENTIFY = '[Analytics] [Checklist] Checklist initial identify',
  CLICKED_ADD_MAIN_TASK_ANALYTICS = '[Analytics] [Checklist] Clicked add main task',
  DELETE_MAIN_TASK_ANALYTICS = '[Analytics] [Checklist] Deleted main task',
  DELETE_TASK_SUB_ANALYTICS = '[Analytics] [Checklist] Deleted subtask',
  FILTER_CHECKLIST_ANALYTICS = '[Analytics] [Checklist] Filtered checklist',
  FOLLOWED_SUBTASKS_LINK_ANALYTICS = '[Analytics] [Checklist] Followed subtasks link',
  INITIALISE_CHECKLIST_ANALYTICS = '[Analytics] [Checklist] Initialised checklist',
  LOADED_RELATED_SUPPLIERS_ANALYTICS = '[Analytics] [Checklist] Loaded related suppliers',
  ON_COPY_TASK_URL_ANALYTICS = '[Analytics] [Checklist] Copied task url',
  ON_EDIT_TASK_ASSIGNEE_ANALYTICS = '[Analytics] [Checklist] Edited task assignee',
  ON_TRIGGER_SOCIAL_SHARE_TASK_ANALYTICS = '[Analytics] [Checklist] Triggered task social share',
  REINITIALISE_CHECKLIST_ANALYTICS = '[Analytics] [Checklist] Reinitialised checklist',
  SAVE_TASK_ASSIGNEE_ANALYTICS = '[Analytics] [Checklist] Saved task assignee',
  SHOW_DETAILS_OPENED_ANALYTICS = '[Analytics] [Checklist] Opened subtasks view',
  TRIGGER_DELETE_TASK_MAIN_ANALYTICS = '[Analytics] [Checklist] Triggered delete main task',
  TRIGGER_DELETE_TASK_SUB_ANALYTICS = '[Analytics] [Checklist] Triggered delete subtask',
  UPDATE_CURRENT_TAG_ANALYTICS = '[Analytics] [Checklist] Changed checklist month',
  UPDATE_SUBTASK_ANALYTICS = '[Analytics] [Checklist] Updated subtask',
  UPDATE_TASK_ANALYTICS = '[Analytics] [Checklist] Updated main task',
  USED_TAB_NAVIGATION_ON_SUBTASK_VIEW_ANALYTICS = '[Analytics] [Checklist] Used tab navigation on subtask view',
}
